import { motion } from "framer-motion";
import { Tooltip } from "react-tooltip";
import { images } from "../../constants";

import { AppWrap, MotionWrap } from "../../wrapper";

import "./Skills.scss";

const skills = [
  { title: "React", icon: images.css },
  { title: "GitHub", icon: images.figma },
  { title: "SASS", icon: images.git },
  { title: "Redux", icon: images.graphql },
  { title: "React", icon: images.html },
  { title: "GitHub", icon: images.javascript },
  { title: "SASS", icon: images.node },
  { title: "Redux", icon: images.mu5 },
];

const experiences = [
  // {
  //   year: 2024,
  //   name: "DevOps Engineering and Cloud Arhitecture",
  //   company: "Clarusway IT School",
  // },
  {
    year: 2024,
    name: "AWS DevOps",
    company: "Clarusway IT School DE",
  },

  {
    year: 2023,
    name: "Full Stack Development",
    company: "Clarusway IT School",
  },
  {
    year: 2021,
    name: "Project Management",
    company: "Berlin School Business & Innovation",
  },
  {
    year: 2015,
    name: "Mechanical Engineering",
    company: "Turkish Defence University",
  },
];

const Skills = () => {
  return (
    <>
      <h2 className="head-text">Skills & Experiences</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill, i) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={i}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={skill.icon} alt={skill.name} />
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>

        <div className="app__skills-exp">
          {experiences.map((experience) => (
            <motion.div className="app__skills-exp-item" key={experience.year}>
              <div className="app__skills-exp-year">
                <p className="bold-text">{experience.year}</p>
              </div>
              <motion.div className="app__skills-exp-works">
                {/* Remove the second experiences.map */}
                {/* Use 'experience' instead of 'work' inside the loop */}
                <>
                  <motion.div
                    whileInView={{ opacity: [0, 1] }}
                    transition={{ duration: 0.5 }}
                    className="app__skills-exp-work"
                    data-tip
                    data-for={experience.name}
                  >
                    <h4 className="bold-text">{experience.name}</h4>
                    <p className="p-text">{experience.company}</p>
                  </motion.div>
                  <Tooltip
                    id={experience.name}
                    effect="solid"
                    arrowColor="#fff"
                    className="skills-tooltip"
                  >
                    {experience.desc}{" "}
                    {/* Make sure you have a 'desc' property in your 'experiences' array */}
                  </Tooltip>
                </>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, "app__skills"),
  "skills",
  "app__whitebg"
);
